import { Link } from "react-router-dom";

/**
 * Panier vide (VVS_MODELE_INTERFACE.md §7.3) : « La référence affiche un
 * panier vide sans aucune relance : occasion manquée. » — VVS corrige en
 * proposant systématiquement un lien vers la boutique, jamais un cul-de-sac
 * silencieux (§7.3, principe repris de §14 « états vides »). Porté depuis
 * apps/web/components/cart/EmptyCart.tsx — seul changement : `next/link` →
 * `react-router-dom` `Link`.
 */
export function EmptyCart() {
  return (
    <div className="flex flex-col items-center gap-4 border border-line bg-white px-6 py-16 text-center">
      <p aria-hidden="true" className="text-4xl">
        🛒
      </p>
      <h1 className="font-display text-xl font-semibold text-ink">Votre panier est vide</h1>
      <p className="max-w-sm text-sm text-muted">
        Découvrez notre sélection et ajoutez vos premiers articles.
      </p>
      <Link
        to="/"
        className="inline-flex items-center justify-center rounded-sm border border-gold bg-gold px-6 py-3 text-sm font-medium uppercase tracking-wide text-navy transition-colors duration-150 hover:border-gold2 hover:bg-gold2"
      >
        Voir la boutique
      </Link>
    </div>
  );
}
